const footerNavigation = document.querySelector('.footer-navigation')

if (footerNavigation) {
  const footerNavigationColumns = footerNavigation.querySelectorAll(
    '.footer-navigation-column'
  )

  footerNavigationColumns.forEach((column) => {
    const target = column.querySelector('.footer-navigation-column__title')

    if (target) {
      target.addEventListener('click', () => {
        // Check if we are on mobile which is below 985px
        if (window.innerWidth > 985) {
          return
        }

        column.classList.toggle('footer-navigation-column--active')
      })
    }
  })
}
